import { render, staticRenderFns } from "./ColorPickerSelected.vue?vue&type=template&id=177f005d"
import script from "./ColorPickerSelected.vue?vue&type=script&lang=js"
export * from "./ColorPickerSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports